import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { uuid } from 'uuidv4';
import { useTranslation } from 'react-i18next';

export const File = props => {
    const { context, element, modelPath } = props;
    const { i18n } = useTranslation();
    const inputModel = context.readModel(modelPath, []);

    const [state, setState] = useState(inputModel.value);

    let hiddenText = useRef(null);
    let fileInput = useRef(null);

    const download = () => {
        if (fileInput.current.files.length === 0 && state.length === 0)
            return;

        if (fileInput.current.files.length === 0 && state.length > 0)
        {
            for (var i = 0, l = state.length; i < l; i++) {
                var item = state[i];
                props.context.download(item.fileId,item.filename);
            }
        }

        if (fileInput.current.files.length > 0)
        {
            for (var n = 0, m = fileInput.current.files.length; n < m; n++)
            {
                let file = fileInput.current.files[n];

                const filename = file.name;
                const filetype = file.type;
                const fr = new FileReader();
                fr.readAsDataURL(file);

                const blob = new Blob([file], { type: filetype });

                props.context.downloadBlob(blob, filename);
            }
        }
    }

    const fileHandleChange = (e) => {
        let files = e.target.files;

        const count = files ? files.length : 0;
        let text = [];
        const newState = [];

        for (var n = 0, m = count; n < m; n++)
        {
            const file = files[n];
            newState.push({ "filename": file.name, "fileId": uuid() });
            text.push(file.name);
        }

        setState(newState);
        hiddenText.current.value = text.join(", ");
        validator();
    }

    const clear = () => {
        setState([]);
        hiddenText.current.value = ""
        fileInput.current.value = "";
        validator();
    }

    const validator = () => {
        const errors = context.validateElement(hiddenText.current, element, hiddenText.current.value);
        context.updateModel(modelPath, state, errors);
    }

    let filenames = [];
    for (var x = 0, z = state.length; x < z; x++)
    {
        filenames.push(state[x].filename);
    }

    useEffect(() => {
        context.validators.subscribe(validator);
        return () => context.validators.unsubscribe(validator);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context, element, modelPath, hiddenText]);

    return (
        <div className="input-group">
            <div className={"custom-file " + i18n.language.substring(0, 2)}>
                <input
                    type="text"
                    ref={hiddenText}
                    autoComplete="off"
                    className={"form-control" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "") + (context.isReadOnly ? "" : " d-none")}
                    disabled={context.isReadOnly}
                    defaultValue={filenames.join(", ")}
                    required={element.required}
                />
                <input
                    type="file"
                    multiple
                    ref={fileInput}
                    aform-path={modelPath}
                    autoComplete="off"
                    className={"custom-file-input" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "") + (context.isReadOnly ? " d-none" : "")}
                    name={element.name}
                    onBlur={validator}
                    onChange={fileHandleChange}
                    onFocus={validator}
                />
                <label className={"custom-file-label" + (context.isReadOnly ? " d-none" : "")} htmlFor={element.name}>{filenames.join(", ")}</label>
            </div>
            <div className="input-group-append">
                {state.length > 0 &&
                    <button className="btn btn-outline-secondary" type="button" onClick={(e) => download()}><FontAwesomeIcon icon="download"></FontAwesomeIcon></button>
                }
                {!context.isReadOnly &&
                    <button className="btn btn-outline-secondary" type="button" onClick={clear}><FontAwesomeIcon icon="trash-alt"></FontAwesomeIcon></button>
                }
            </div>
        </div>
    )
}

export default File;